import MiddleBar from './MiddleBar'
import {MiddleBarButton} from './MiddleBar.styled'

export default MiddleBar
export {MiddleBarButton}
